import { useRouter, useRouterState } from '@tanstack/react-router';
import { useAccessContext } from '@/routing/useAccessContext';
import { useRouteMessage } from '@/routing/route-messages';
import { canAccessAppRouteMeta } from '@/routing/access-meta';
import type { ChatToolResultPage } from '@/components/common/chat/useChatToolResultRenderer';
import { buildAgentPageCatalog } from './agentPageCatalog';
import { getFlatRoutes } from '@/routing/flat-routes';

/**
 * Catalog of pages this user can reach (RBAC/module/flag-filtered, real
 * routes only, current page excluded) — what the agent's `find_pages`
 * searches and what its rendered nav buttons are validated against. Pages are
 * named as the app names them, and record pages (`/workbooks/$workbookId`)
 * are listed as patterns. Shared by the default surface and every page
 * surface so navigation works everywhere.
 */
export function useNavigablePages(): ChatToolResultPage[] {
  const router = useRouter();
  const accessCtx = useAccessContext();
  const routeMessage = useRouteMessage();
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  // Walks every route; React Compiler rebuilds it only when access, language
  // or page changes.
  return buildAgentPageCatalog(getFlatRoutes(router), {
    canAccess: (meta) => canAccessAppRouteMeta(meta, accessCtx),
    translate: routeMessage,
    currentPath: pathname,
  });
}
